import type { CarouselApi } from '~/components/ui/carousel';

import { useIndexScrollVelocity } from '~/composables/useIndexScrollVelocity';

export function useSwipeVelocity(emblaApi: Ref<CarouselApi | null>) {
	const { direction, isFastScrolling, report } = useIndexScrollVelocity();

	function onSelect() {
		const api = emblaApi.value;
		if (!api) return;
		report(api.selectedScrollSnap());
	}

	watch(
		emblaApi,
		(api, _old, onCleanup) => {
			if (!api) return;
			api.on('select', onSelect);
			onCleanup(() => api.off('select', onSelect));
		},
		{ immediate: true }
	);

	return { direction, isFastScrolling };
}
